<template>
  <button class="hamburger"
          @click="toggleActiveState"
          :class="[this.hamburgerClass, {'is-active': this.isActive}]"
          type="button"
  >
    <span class="hamburger-box">
      <span class="hamburger-inner"></span>
    </span>
  </button>
</template>

<script>
export default {
  name: 'Hamburger.vue',
  computed: {
    hamburgerClass() {
      return `hamburger--${this.type}`;
    },
  },
  methods: {
    toggleActiveState() {
      this.isActive = !this.isActive;
      this.$emit('toggle', this.isActive);
    },
    close() {
      this.isActive = false;
      this.$emit('toggle', this.isActive);
    },
  },
  data() {
    return {
      windowWidth: window.innerWidth,
      isActive: false,
    };
  },
  watch: {
    $route(to, from) {
      if (to !== from) {
        this.close();
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.close);
    });
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.close);
  },
  props: {
    type: {
      default: 'minus',
      validator: (value) => ([
        '3dx',
        '3dx-r',
        '3dy',
        '3dy-r',
        '3dxy',
        '3dxy-r',
        'arrow',
        'arrow-r',
        'arrowalt',
        'arrowalt-r',
        'arrowturn',
        'arrowturn-r',
        'boring',
        'collapse',
        'collapse-r',
        'elastic',
        'elastic-r',
        'emphatic',
        'emphatic-r',
        'minus',
        'slider',
        'slider-r',
        'spin',
        'spin-r',
        'spring',
        'spring-r',
        'stand',
        'stand-r',
        'squeeze',
        'vortex',
        'vortex-r',
      ].indexOf(value) !== -1),
    },
  },
};
</script>
